<template>
  <el-drawer title="未缴明细" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthSpecial" @close="indexThis.showParkSpacePreview = false">
    <el-card>
      <el-table :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="收费科目" align="center">
          <template slot-scope="scope">
            {{ scope.row.itemName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="欠费开始日期" align="center">
          <template slot-scope="scope">
            {{ cutTime(scope.row.billDate, ' ') }}
          </template>
        </el-table-column>
        <el-table-column label="欠费时长" align="center">
          <template slot-scope="scope">
            <span v-if="Number(scope.row.overdueDays) && Number(scope.row.overdueMouths)">{{ `${scope.row.overdueMouths}月${scope.row.overdueDays}天` }}</span>
            <span v-if="Number(scope.row.overdueMouths) && !Number(scope.row.overdueDays)">{{ scope.row.overdueMouths }}月</span>
            <span v-if="Number(scope.row.overdueDays) && !Number(scope.row.overdueMouths)">{{ scope.row.overdueDays }}天</span>
            <span v-if="!Number(scope.row.overdueDays) && !Number(scope.row.overdueMouths)">-</span>
          </template>
        </el-table-column>
        <el-table-column label="欠费金额" align="center">
          <template slot-scope="scope">
            {{ keepTwoDecimal(scope.row.orderAmount) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper,sizes"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 50, 100]"
        :total="total"
        @size-change="currentChange"
        @current-change="currentChange"
      />
    </el-card>
  </el-drawer>
</template>

<script>
import { unPayDetailPage, unPayDetailCount } from '@/api/finance'
export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      previewForm: {},
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      queryData: {},
    }
  },
  methods: {
    async unPayDetailPage() {
      const { data } = await unPayDetailPage({ ...this.queryData, ...this.page })
      this.tableData = data
      const { data: total } = await unPayDetailCount({ ...this.page, ...this.queryData })
      this.total = Number(total)
    },
    currentChange() {
      this.unPayDetailPage()
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-form-item__label {
  text-align: left !important;
}
</style>
